<div class="playlists layout-spacing" data-testid="playlists-playlists-div">
    <!-- Content to be projected into the sub-navbar component via content projection -->
    <ng-template #subNavBarContent>
        <app-button
            label="Create Playlist"
            iconKey="plus"
            gap="gap-3"
            (buttonClick)="onCreatePlaylist()" />
    </ng-template>

    <div class="playlists__stats" data-testid="playlists-playlists-stats-div">
        @for (stat of playlistsStats(); track stat.title) {
            <app-stats-card
                [statsData]="stat"
                [hasTotal]="true"
                [isLoading]="isLoadingPlaylistStats()" />
        }
    </div>
    <div class="playlists__toolbar" data-testid="playlists-playlists-toolbar-div">
        <app-table-toolbar
            [buttons]="toolbarButtons"
            placeholder="Search Playlist Name"
            (searchValueChange)="searchKey.set($event)"></app-table-toolbar>
    </div>
    <div class="playlists__table main-table-container" data-testid="playlists-playlists-table-div">
        <app-table
            [filterEnabled]="true"
            tableTitle="Playlists"
            [columns]="tableColumns"
            [showItemCount]="true"
            [totalDataLength]="pagination().totalCount"
            [loading]="isLoadingPlaylists() || isPaginating() || isFiltering()"
            [isColumnFiltering]="isFiltering()"
            [data]="playlistData()"
            tableHeight="auto"
            [pageSize]="pageSize"
            (actionClick)="onTableAction($event)"
            (showMoreRequested)="onShowMoreRequested()"
            (showLessRequested)="onShowLess()"
            (tableStateChange)="onTableStateChange($event)"
            (cellClick)="onCellClick($event)"></app-table>
    </div>
</div>

<!-- Delete Confirmation Modal -->
@if (showDeleteConfirmationModal()) {
    <app-confirmation-modal
        [isVisible]="showDeleteConfirmationModal()"
        [type]="'warning'"
        title="Delete Playlist"
        [message]="
            'Are you sure you want to delete \'' +
            $safeNavigationMigration(selectedPlaylistToDelete()?.playlistName) +
            '\'? This action cannot be undone.'
        "
        confirmText="Delete"
        cancelText="Cancel"
        [showCancelButton]="true"
        [loopAnimation]="false"
        [isLoading]="isDeletingPlaylist()"
        (confirm)="onConfirmDelete()"
        (cancel)="onCancelDelete()"
        (modalClose)="onCancelDelete()" />
}

<!-- Push Updates Confirmation Modal -->
@if (showPushUpdatesModal()) {
    <app-confirmation-modal
        [isVisible]="showPushUpdatesModal()"
        size="small"
        type="warning"
        [showCancelButton]="true"
        title="Push Updates"
        [message]="pushUpdatesMessage()"
        confirmText="Push Updates"
        cancelText="Cancel"
        [loopAnimation]="false"
        [isLoading]="isLoadingPushUpdatesLicenses()"
        (confirm)="onConfirmPushUpdates()"
        (cancel)="onCancelPushUpdates()"
        (modalClose)="onCancelPushUpdates()" />
}

<!-- Result Confirmation Modal -->
@if (showResultModal()) {
    @if (showResultModal()) {
        <app-confirmation-modal
            [isVisible]="showResultModal()"
            [type]="modalConfig().type"
            [title]="modalConfig().title"
            [message]="modalConfig().message"
            [loopAnimation]="false"
            confirmText="Close"
            (confirm)="onResultModalClose()"
            (modalClose)="onResultModalClose()" />
    }
}
